import post1Img from "../assets/post1.png";
import post2Img from "../assets/post2.png";
import post3Img from "../assets/post3.png";
import post4Img from "../assets/post4.png";

export const blogPosts = [
  {
    id: 1,

    slug: "estufa-pellets-no-enciende-causas-soluciones",

    titleKey: "blog.post1Title",
    excerptKey: "blog.post1Excerpt",
    descriptionKey: "blog.post1Excerpt",

    dateKey: "blog.post1Date",
    publishedTime: "2026-06-20",

    sectionsKey: "blog.post1Sections",
    faqKey: "blog.post1Faq",

    readingTimeKey: "blog.post1ReadingTime",

    category: "repair",

    tags: [
      "blog.tags.breakdowns",
      "blog.tags.maintenance"
    ],

    keywords: [
      "pellet stove",
      "pellet stove won't ignite",
      "pellet stove ignition",
      "igniter",
      "burn pot",
      "maintenance",
      "pellets",
      "biomass"
    ],

    image: "/post1.png",
    img: post1Img
  },

  {
    id: 2,

    slug: "cambiar-resistencia-encendido-estufa-pellets",

    titleKey: "blog.post2Title",
    excerptKey: "blog.post2Excerpt",
    descriptionKey: "blog.post2Excerpt",

    dateKey: "blog.post2Date",
    publishedTime: "2026-06-23",

    sectionsKey: "blog.post2Sections",
    faqKey: "blog.post2Faq",

    readingTimeKey: "blog.post2ReadingTime",

    category: "repair",

    tags: [
      "blog.tags.tutorial",
      "blog.tags.igniters"
    ],

    keywords: [
      "pellet stove igniter",
      "replace igniter",
      "ignition resistance",
      "pellet stove repair",
      "ceramic igniter",
      "heating",
      "pellet stove maintenance"
    ],

    image: "/post2.png",
    img: post2Img
  },

  {
    id: 3,

    slug: "motorreductor-estufa-pellets-sintomas-averia",

    titleKey: "blog.post3Title",
    excerptKey: "blog.post3Excerpt",
    descriptionKey: "blog.post3Excerpt",

    dateKey: "blog.post3Date",
    publishedTime: "2026-06-26",

    sectionsKey: "blog.post3Sections",
    faqKey: "blog.post3Faq",

    readingTimeKey: "blog.post3ReadingTime",

    category: "repair",

    tags: [
      "blog.tags.gearmotors",
      "blog.tags.breakdowns"
    ],

    keywords: [
      "gear motor",
      "pellet stove gear motor",
      "auger motor",
      "pellet feed",
      "pellet stove repair",
      "gearbox",
      "auger"
    ],

    image: "/post3.png",
    img: post3Img
  },

  {
    id: 4,

    slug: "como-limpiar-estufa-pellets",

    titleKey: "blog.post4Title",
    excerptKey: "blog.post4Excerpt",
    descriptionKey: "blog.post4Excerpt",

    dateKey: "blog.post4Date",
    publishedTime: "2026-06-29",

    sectionsKey: "blog.post4Sections",
    faqKey: "blog.post4Faq",

    readingTimeKey: "blog.post4ReadingTime",

    category: "maintenance",

    tags: [
      "blog.tags.maintenance",
      "blog.tags.cleaning"
    ],

    keywords: [
      "clean pellet stove",
      "pellet stove maintenance",
      "burn pot cleaning",
      "ash removal",
      "chimney",
      "pellet stove cleaning"
    ],

    image: "/post4.png",
    img: post4Img
  }
];